import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { DateTimePipe } from 'src/app/shared/pipe/date.pipe';
import { map } from 'rxjs/operators';

@Component({
  selector: 'lifedi-spider-informant',
  templateUrl: './spider-informant.component.html',
  styleUrls: ['./spider-informant.component.scss']
})
export class SpiderInformantComponent implements OnInit {
  @ViewChild('RadarChart') RadarChart: ElementRef;
  @ViewChild('RadarChartPdf') RadarChartPdf: ElementRef;
  @ViewChild('RadarChartInformant') RadarChartInformant: ElementRef;
  @ViewChild('RadarChartPdfInformant') RadarChartPdfInformant: ElementRef;

  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;

  isLoading: boolean;
  data_report;

  radarChart: any;
  radarChartPdf: any;
  radarChartInformant: any;
  radarChartPdfInformant: any;


  constructor(private measureService: MeasureService) { }

  ngOnInit(): void {
    Chart.register(...registerables);

    let body;
    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }

    this.getReport(body);
  }

  getReport(body) {
    this.measureService.getReportByMeasureId(body).pipe(
      map(res => {
        this.data_report = res.result;

        let allgroups = this.data_report.data;
        let allgroupsInformant = this.data_report.data2;

        let alllabels = [];
        let datasets = [];

        let alllabelsInformant = [];
        let datasetsInformant = [];

        let chart1: boolean = false;
        let chart2: boolean = false;

        for (let i = 0; i < allgroups.length; i++) {
          datasets.push({
            data: allgroups[i].values,
            label: allgroups[i].group_name,
            backgroundColor: allgroups[i].group_color + '80',
            fill: true,
            borderColor: 'transparent',
            pointRadius: 0,
          });
          for (let j = 0; j < allgroups[i].psy_data.length; j++) {
            alllabels.push(allgroups[i].psy_data[j].psy_name);
          }

          chart1 = i === allgroups.length - 1 ? true : false;
        }

        for (let i = 0; i < allgroupsInformant.length; i++) {
          datasetsInformant.push({
            data: allgroupsInformant[i].values,
            label: allgroupsInformant[i].group_name,
            backgroundColor: allgroupsInformant[i].group_color + '80',
            fill: true,
            borderColor: 'transparent',
            pointRadius: 0,
          });
          for (let j = 0; j < allgroupsInformant[i].psy_data.length; j++) {
            alllabelsInformant.push(allgroupsInformant[i].psy_data[j].psy_name);
          }
          chart2 = i === allgroupsInformant.length - 1 ? true : false;
        }

        this.setChart(alllabels, datasets, alllabelsInformant, datasetsInformant);
      })
    ).subscribe();
  }

  setChart(alllabels, datasets, alllabelsInformant, datasetsInformant) {
    console.log(alllabels, datasets);
    console.log(alllabelsInformant, datasetsInformant);
    const adjustPadding = (label) => {
      let pad;
      if (alllabels.length > 25) {
        let all_lb: number = alllabels.length,
          last_index: number = all_lb - 1,
          half: number = all_lb / 2,
          half_index: number = parseInt(half.toFixed(0)),
          half_before1: number = half_index - 1,
          half_before2: number = half_index - 2,
          half_after1: number = half_index + 1;

        switch (label.index) {
          case 0: pad = 30; break;
          case 1: pad = 20; break;
          case half_before2: pad = 20; break;
          case half_before1: pad = 30; break;
          case half_index: pad = 30; break;
          case half_after1: pad = 20; break;
          case last_index: pad = 20; break;
          default: pad = 10; break;
        }
      } else {
        pad = 10
      }
      return pad
    }

    let context = this.RadarChart.nativeElement.getContext('2d')
    let contextPdf = this.RadarChartPdf.nativeElement.getContext('2d')
    let contextInformant = this.RadarChartInformant.nativeElement.getContext('2d')
    let contextInformantPdf = this.RadarChartPdfInformant.nativeElement.getContext('2d')

    let data = {
      labels: alllabels,
      datasets: datasets,
    };
    let informantData = {
      labels: alllabelsInformant,
      datasets: datasetsInformant,
    };
    let option = {
      font: {
        family: 'Sarabun',
      },
      color: '#000',
      devicePixelRatio: 4,
      responsive: true,
      scales: {
        r: {
          suggestedMax: this.data_report.max,
          beginAtZero: true,
          pointLabels: {
            font: {
              size: 8,
            },
            padding: adjustPadding,
            color: '#000',
          }
        },
        y: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
          display: false,
        },
      },
      plugins: {
        legend: {
          labels: {
            font: {
              family: 'Sarabun',
            },
          },
        },
      },
    };

    let optionPdf = {
      font: {
        family: 'Sarabun',
      },
      color: '#000',
      devicePixelRatio: 4,
      responsive: true,
      scales: {
        r: {
          suggestedMax: this.data_report.max,
          beginAtZero: true,
          pointLabels: {
            font: {
              size: 6,
            },
            padding: adjustPadding,
            color: '#000',
          }
        },
        y: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
          display: false,
        },
      },
      plugins: {
        legend: {
          labels: {
            font: {
              family: 'Sarabun',
            },
          },
        },
      },
    };

    let radarChartPdf = new Chart(contextPdf, {
      type: 'radar',
      data: data,
      options: optionPdf
    });

    let radarChart = new Chart(context, {
      type: 'radar',
      data: data,
      options: option,
    });

    let radarChartInformant = new Chart(contextInformant, {
      type: 'radar',
      data: informantData,
      options: option,
    });

    let radarChartPdfInformant = new Chart(contextInformantPdf, {
      type: 'radar',
      data: informantData,
      options: optionPdf
    });

    this.isLoading = true;
    setTimeout(() => {
      this.filepdf('email');
      this.isLoading = false;
    }, 4000);
  }

  filepdf(transfer) {
    let formattedDate = new DateTimePipe().transform(
      this.data_report.done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report.user_id;
    const scale = 2;
    let radar: string = '';
    let radarInformant: string = '';

    let radarCharts = [
      document.getElementById('RadarChartPdf'),
      document.getElementById('RadarChartPdfInformant')
    ];

    Promise.all(radarCharts.map((node) => domtoimage.toPng(node,
      {
        quality: 1,
        width: node.clientWidth * scale,
        height: node.clientHeight * scale,
      }
    )
    )).then(
      (dataArray) => {
        radar = dataArray[0];
        radarInformant = dataArray[1];
        console.log(dataArray)

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text:
                  userid +
                  ' | ' +
                  formattedDate +
                  ' หน้า ' +
                  currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report.reportname,
              alignment: 'center',
              fontSize: 24,
              decoration: '',
              color: '#060e9f',
              margin: [0, 10],
              pageBreak: '',
              bold: true,
            },
            {
              text: this.data_report.measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 15],
            },
            {
              table: {
                headerRows: 1,
                widths: [100],
                heights: [-4],
                body: [
                  [
                    {
                      text: 'ผู้ทำแบบทดสอบ',
                      fontSize: 13,
                      bold: true,
                      aligment: 'center',
                      fillColor: '#060e9f',
                      border: [true, true, true, true],
                      color: '#ffffff',
                      alignment: 'center',
                      margin: [0, 0],
                      borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                    }
                  ]
                ]
              }
            },
            {
              image: dataArray[0],
              width: 570,
              alignment: 'center',
              margin: [0, 20, 0, 10],
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };

        let allgroups = this.data_report.data;
        // console.log(allgroups);
        for (let i = 0; i < allgroups.length; i++) {
          allPage.content.push({
            text: allgroups[i].group_name,
            alignment: 'center',
            fontSize: 20,
            color: allgroups[i].group_color,
            margin: [0, 30, 0, 0],
            decoration: 'underline',
            pageBreak: 'before',
            bold: true,
          });
          for (let j = 0; j < allgroups[i].psy_data.length; j++) {
            // console.log(allgroups[i].group_color);

            allPage.content.push(
              {
                text: allgroups[i].psy_data[j].psy_name,
                alignment: 'left',
                fontSize: 18,
                decoration: 'underline',
                color: allgroups[i].group_color,
                margin: [0, 20, 0, 0],
                pageBreak: '',
                bold: true,
              },
              {
                text: allgroups[i].psy_data[j].psy_description,
                alignment: 'left',
                fontSize: 14,
                decoration: '',
                color: '#000000',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
              },
              {
                text:
                  'ท่านได้ ' +
                  parseFloat(allgroups[i].psy_data[j].value).toFixed(2) +
                  ' คะแนน',
                alignment: 'left',
                fontSize: 18,
                color: allgroups[i].group_color,
                margin: [0, 5, 0, 0],
                pageBreak: '',
                bold: true,
                decoration: '',
              },
              {
                text: allgroups[i].psy_data[j].range_description,
                alignment: 'left',
                fontSize: 14,
                color: '#000000',
                margin: [0, 10, 0, 10],
                pageBreak: '',
                bold: false,
                decoration: '',
              },
              {
                text: '_____________________________________________________________________________________________',
                alignment: 'center',
                fontSize: 10,
                color: 'gray',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
                decoration: '',
              }
            );
          }
        }

        let parances = [];
        this.data_report.parances.forEach(e => {
          parances.push(`${e.EMAIL} (${e.TAG})`)
        });
        let parancesStr = (parances.join()).replace(/,/g, ', ')

        allPage.content.push(
          {
            text: '',
            alignment: 'center',
            fontSize: 10,
            color: 'gray',
            margin: [0, 0, 0, 0],
            pageBreak: 'after',
            bold: false,
            decoration: '',
          },
          {
            text: '',
            width: '*',
            fontSize: 14,
            margin: [0, 0, 0, 5],
          },
          {
            table: {
              headerRows: 1,
              widths: [120],
              heights: [-5],
              body: [
                [
                  {
                    text: 'ผู้มีส่วนร่วมในแบบทดสอบนี้',
                    fontSize: 15,
                    bold: true,
                    aligment: 'center',
                    fillColor: '#060e9f',
                    border: [true, true, true, true],
                    color: '#ffffff',
                    alignment: 'center',
                    margin: [0, 0],
                    borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                  }
                ]
              ]
            }
          },
          {
            text: 'รายงานผลของผู้มีส่วนร่วมนี้เป็นของ',
            alignment: 'left',
            fontSize: 16,
            color: '#000',
            margin: [0, 10, 0, 8],
            pageBreak: '',
            bold: true,
            decoration: '',
          },
          {
            text: parancesStr,
            width: '*',
            fontSize: 15,
            margin: [0, 0, 0, 25],
          },
          {
            image: dataArray[1],
            width: 570,
            alignment: 'center',
            margin: [0, 20, 0, 10],
          },
        )

        let allgroups2 = this.data_report.data2;
        // console.log(allgroups);
        for (let i = 0; i < allgroups2.length; i++) {
          allPage.content.push({
            text: allgroups2[i].group_name,
            alignment: 'center',
            fontSize: 20,
            color: allgroups2[i].group_color,
            margin: [0, 30, 0, 0],
            decoration: 'underline',
            pageBreak: 'before',
            bold: true,
          });
          for (let j = 0; j < allgroups2[i].psy_data.length; j++) {
            // console.log(allgroups2[i].group_color);

            allPage.content.push(
              {
                text: allgroups2[i].psy_data[j].psy_name,
                alignment: 'left',
                fontSize: 18,
                decoration: 'underline',
                color: allgroups2[i].group_color,
                margin: [0, 20, 0, 0],
                pageBreak: '',
                bold: true,
              },
              {
                text: allgroups2[i].psy_data[j].psy_description,
                alignment: 'left',
                fontSize: 14,
                decoration: '',
                color: '#000000',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
              },
              {
                text:
                  'ท่านได้ ' +
                  parseFloat(allgroups2[i].psy_data[j].value).toFixed(2) +
                  ' คะแนน',
                alignment: 'left',
                fontSize: 18,
                color: allgroups2[i].group_color,
                margin: [0, 5, 0, 0],
                pageBreak: '',
                bold: true,
                decoration: '',
              },
              {
                text: allgroups2[i].psy_data[j].range_description,
                alignment: 'left',
                fontSize: 14,
                color: '#000000',
                margin: [0, 10, 0, 10],
                pageBreak: '',
                bold: false,
                decoration: '',
              },
              {
                text: '_____________________________________________________________________________________________',
                alignment: 'center',
                fontSize: 10,
                color: 'gray',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
                decoration: '',
              }
            );
          }
        }

        if (transfer === 'email') {
          let pdfDocGenerator = pdfMake.createPdf(allPage);
          pdfDocGenerator.getBase64((base64str) => {
            // console.log(base64str);
            let data = {
              MEASURE_ID: this.measureid,
              TYPE: this.type,
              base64str: base64str,
              view: this.view_status,
            };
            this.measureService.SaveReportMeasureId(data).subscribe((res) => {
              // console.log(res);
            });
          });
        } else if (transfer === 'download') {
          pdfMake.createPdf(allPage).open();
        }
      }
    );
  }

}
